"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6297],{

/***/ 26297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Kt": function() { return /* reexport */ GNB_HOMEIDEA_MODULE_BY_TEMPLATE_NO; },
  "QS": function() { return /* reexport */ GNB_MALL_MODULE_BY_TEMPLATE_NO; },
  "Jt": function() { return /* reexport */ GNB_REMODELING_MODULE_BY_TEMPLATE_NO; },
  "H_": function() { return /* reexport */ GetComponentDataGateway; },
  "KR": function() { return /* reexport */ GetComponentListGateway; },
  "PY": function() { return /* reexport */ GetConstructCaseCheckCounselor; },
  "JA": function() { return /* reexport */ GetConstructionCaseListGateway; },
  "Jk": function() { return /* reexport */ GetDisplayInfoGateway; },
  "Rh": function() { return /* reexport */ GetEventConsultChannelInfoGateway; },
  "JT": function() { return /* reexport */ GetEventDetailGateway; },
  "$t": function() { return /* reexport */ GetEventListGateway; },
  "Pw": function() { return /* reexport */ GetGoodsCategoryGateway; },
  "no": function() { return /* reexport */ GetHamburgerMenusGateway; },
  "e2": function() { return /* reexport */ GetRemoteConfigGateway; },
  "PC": function() { return /* reexport */ GetTemplateInfoGateway; },
  "Fg": function() { return /* reexport */ parseCounselorYn; }
});

// UNUSED EXPORTS: GNB_HOMEIDEA_TEMPLATE_NO_BY_MODULE, GNB_MALL_SNB_CD_BY_TEMPLATE_NO, GNB_REMODELING_TEMPLATE_NO_BY_MODULE, GetFavoriteTestStartGateway, GetFavoriteTestStyleGateway, GetGoodsDetailGateway, GetHamburgerCategoryGateway, GetMenusGateway, SendFavoriteTestGateway

;// CONCATENATED MODULE: ../../shared/content/src/constants/display.ts
/**
 * 전시 GNB 템플릿 매핑 (typeValue=MOBILE)
 *
 * display/gnb-list API 호출을 제거하면서(HSMALL-17123) 해당 응답을 상수화한 것이다.
 * dev/qa/stg/prod 응답이 모두 동일함을 확인했다 (2026-09-02 기준).
 *
 * 전시 어드민에서 GNB 템플릿을 재발번하면 이 표도 함께 갱신해야 한다.
 */ var GNB_REMODELING_TEMPLATE_NO_BY_MODULE = {
    GnbRemodelingSection: "343",
    GnbRemodelingShop: "344",
    GnbRemodelingGoods: "345",
    GnbRemodelingStart: "346",
    GnbRemodelingEvent: "347"
};
var GNB_MALL_MODULE_BY_TEMPLATE_NO = {
    "333": "home",
    "39": "deal"
};
/** MALL GNB 하위 SNB (dispTemplateNo → snbCd) */ var GNB_MALL_SNB_CD_BY_TEMPLATE_NO = {
    "334": "today",
    "336": "ssem",
    "335": "oulet"
};
var GNB_HOMEIDEA_MODULE_BY_TEMPLATE_NO = {
    "338": "recommend",
    "339": "spaceandphoto",
    "340": "apartment",
    "341": "constcase",
    "342": "magazine"
};
var invert = function(source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[source[key]] = key;
        return acc;
    }, {});
};
var GNB_REMODELING_MODULE_BY_TEMPLATE_NO = invert(GNB_REMODELING_TEMPLATE_NO_BY_MODULE);
var GNB_HOMEIDEA_TEMPLATE_NO_BY_MODULE = invert(GNB_HOMEIDEA_MODULE_BY_TEMPLATE_NO);

;// CONCATENATED MODULE: ../../shared/content/src/constants/index.ts


// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ../../shared/content/src/adapter/gateway/category.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var GetGoodsCategoryGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetGoodsCategoryGateway(httpClient) {
        _classCallCheck(this, GetGoodsCategoryGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetGoodsCategoryGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/content-info-service/api/v1/categories/cascade"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetGoodsCategoryGateway;
}();
var GetHamburgerCategoryGateway = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function GetHamburgerCategoryGateway(httpClient) {
        _classCallCheck(this, GetHamburgerCategoryGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetHamburgerCategoryGateway.prototype;
    _proto.exec = function exec() {
        var _this = this;
        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/content-service/api/v1/categories/hs-mall/navigation-list-all"),
                            body: {
                                typeValue: "MOBILE"
                            }
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetHamburgerCategoryGateway;
}()));

// EXTERNAL MODULE: ../../.yarn/cache/query-string-npm-7.1.1-55c6f31f52-b227d1f588.zip/node_modules/query-string/index.js
var query_string = __webpack_require__(46757);
;// CONCATENATED MODULE: ../../shared/content/src/adapter/gateway/construction-case.ts
function construction_case_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function construction_case_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                construction_case_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                construction_case_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function construction_case_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}


/**
 * 시공사례 목록 조회 API
 *
 * VLOW-160: content-service -> content-info-service 이관.
 * 요청 파라미터와 JSON 구조는 동일하나 데이터소스가 한샘몰 프록시에서
 * 내부 DB 직접 조회로 바뀌어 detailUrl/imageUrl 생성 방식이 달라진다.
 */ var GetConstructionCaseListGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetConstructionCaseListGateway(httpClient) {
        construction_case_classCallCheck(this, GetConstructionCaseListGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetConstructionCaseListGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return construction_case_asyncToGenerator(runtime_default().mark(function _callee() {
            var query;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        query = query_string.stringify(req);
                        _ctx.next = 3;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/content-info-service/api/v1/constructCase?").concat(query)
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetConstructionCaseListGateway;
}();
/**
 * 전문가 콘텐츠를 파악하는 API
 *
 * VLOW-163: content-service -> content-info-service 이관.
 * 응답 counselorYn 형식이 'true'/'false' 에서 'Y'/'N' 으로 바뀌므로
 * 해석은 parseCounselorYn 을 거쳐야 한다.
 */ var GetConstructCaseCheckCounselor = /*#__PURE__*/ function() {
    "use strict";
    function GetConstructCaseCheckCounselor(httpClient) {
        construction_case_classCallCheck(this, GetConstructCaseCheckCounselor);
        this.httpClient = httpClient;
    }
    var _proto = GetConstructCaseCheckCounselor.prototype;
    _proto.exec = function exec() {
        var _this = this;
        return construction_case_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/content-info-service/api/v1/constructCase/checkCounselor")
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetConstructCaseCheckCounselor;
}();

;// CONCATENATED MODULE: ../../shared/content/src/adapter/gateway/goods.ts
function goods_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function goods_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                goods_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                goods_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function goods_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var GetGoodsDetailGateway = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function GetGoodsDetailGateway(httpClient) {
        goods_classCallCheck(this, GetGoodsDetailGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetGoodsDetailGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return goods_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/content-service/api/v1/goods/").concat(req.goodsId)
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetGoodsDetailGateway;
}()));

// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/lodash.js
var lodash = __webpack_require__(35735);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ../../shared/content/src/adapter/gateway/event.ts
function event_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function event_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                event_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                event_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function event_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}



var GetEventListGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetEventListGateway(httpClient) {
        event_classCallCheck(this, GetEventListGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetEventListGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return event_asyncToGenerator(runtime_default().mark(function _callee() {
            var query;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        query = query_string.stringify(req);
                        _ctx.next = 3;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/content-service/api/v1/events?").concat(query)
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetEventListGateway;
}();
var GetEventDetailGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetEventDetailGateway(httpClient) {
        event_classCallCheck(this, GetEventDetailGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetEventDetailGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return event_asyncToGenerator(runtime_default().mark(function _callee() {
            var query;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        query = query_string.stringify(lodash_default().omit(req, "shpNo"));
                        _ctx.next = 3;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/content-service/api/v1/events/").concat(req.shpNo, "?").concat(query)
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetEventDetailGateway;
}();
var GetEventConsultChannelInfoGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetEventConsultChannelInfoGateway(httpClient) {
        event_classCallCheck(this, GetEventConsultChannelInfoGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetEventConsultChannelInfoGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return event_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/content-service/api/v1/events/").concat(req.shpNo, "/consult-channel-info")
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetEventConsultChannelInfoGateway;
}();

;// CONCATENATED MODULE: ../../shared/content/src/adapter/gateway/favorite-test.ts
function favorite_test_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function favorite_test_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                favorite_test_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                favorite_test_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function favorite_test_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var GetFavoriteTestStartGateway = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function GetFavoriteTestStartGateway(httpClient) {
        favorite_test_classCallCheck(this, GetFavoriteTestStartGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetFavoriteTestStartGateway.prototype;
    _proto.exec = function exec() {
        var _this = this;
        return favorite_test_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/content-service/api/v1/favorite-test")
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetFavoriteTestStartGateway;
}()));
var SendFavoriteTestGateway = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function SendFavoriteTestGateway(httpClient) {
        favorite_test_classCallCheck(this, SendFavoriteTestGateway);
        this.httpClient = httpClient;
    }
    var _proto = SendFavoriteTestGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return favorite_test_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "POST",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/content-service/api/v1/favorite-test/feedback"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return SendFavoriteTestGateway;
}()));
var GetFavoriteTestStyleGateway = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function GetFavoriteTestStyleGateway(httpClient) {
        favorite_test_classCallCheck(this, GetFavoriteTestStyleGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetFavoriteTestStyleGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return favorite_test_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/content-service/api/v1/favorite-test/styles/").concat(req.styleId)
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetFavoriteTestStyleGateway;
}()));

;// CONCATENATED MODULE: ../../shared/content/src/adapter/gateway/display.ts
function display_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function display_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                display_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                display_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function display_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var GetMenusGateway = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function GetMenusGateway(httpClient) {
        display_classCallCheck(this, GetMenusGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetMenusGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return display_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/content-info-service/api/v1/display/menus"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetMenusGateway;
}()));
var GetHamburgerMenusGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetHamburgerMenusGateway(httpClient) {
        display_classCallCheck(this, GetHamburgerMenusGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetHamburgerMenusGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return display_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com", "/hanssem/display-service/api/v1/menus"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetHamburgerMenusGateway;
}();
var GetDisplayInfoGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetDisplayInfoGateway(httpClient) {
        display_classCallCheck(this, GetDisplayInfoGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetDisplayInfoGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return display_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/content-service/api/v1/display/display-info"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetDisplayInfoGateway;
}();
var GetTemplateInfoGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetTemplateInfoGateway(httpClient) {
        display_classCallCheck(this, GetTemplateInfoGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetTemplateInfoGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return display_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/content-info-service/api/v1/display/template-info"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetTemplateInfoGateway;
}();

;// CONCATENATED MODULE: ../../shared/content/src/adapter/gateway/component.ts
function component_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function component_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                component_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                component_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function component_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var GetComponentDataGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetComponentDataGateway(httpClient) {
        component_classCallCheck(this, GetComponentDataGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetComponentDataGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return component_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/content-service/api/v1/display/component-data"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetComponentDataGateway;
}();
var GetComponentListGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetComponentListGateway(httpClient) {
        component_classCallCheck(this, GetComponentListGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetComponentListGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return component_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/content-service/api/v1/display/components"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetComponentListGateway;
}();

;// CONCATENATED MODULE: ../../shared/content/src/adapter/gateway/remote-config.ts
function remote_config_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function remote_config_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                remote_config_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                remote_config_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function remote_config_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * 리모트 컨피그 단일 조회 — GET /api/v1/configs/{key}
 *
 * 미등록 key 는 HTTP 200 + data: null.
 */ var GetRemoteConfigGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetRemoteConfigGateway(httpClient) {
        remote_config_classCallCheck(this, GetRemoteConfigGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetRemoteConfigGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return remote_config_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/display-service/api/v1/configs/").concat(encodeURIComponent(req.key))
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetRemoteConfigGateway;
}();

;// CONCATENATED MODULE: ../../shared/content/src/adapter/gateway/index.ts









;// CONCATENATED MODULE: ../../shared/content/src/adapter/index.ts


;// CONCATENATED MODULE: ../../shared/content/src/utils/counselor.ts
/**
 * 전문가(홈에디터) 콘텐츠 보유 여부 응답값을 boolean 으로 변환한다.
 *
 * checkCounselor API 가 content-info-service 로 이관되면서(VLOW-100)
 * 응답이 'true'/'false' 에서 'Y'/'N' 으로 바뀌었다.
 */ var parseCounselorYn = function(counselorYn) {
    return counselorYn === "Y";
};

;// CONCATENATED MODULE: ../../shared/content/src/utils/index.ts


;// CONCATENATED MODULE: ../../shared/content/src/index.ts






/***/ })

}]);